import FeeModulePage from "./FeeModulePage";
export default function ResidenceFees() {
  return <FeeModulePage module="residence" />;
}
